var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{ref:"input",class:['text-right', _vm.css],attrs:{"type":"text","value":_vm.displayValue,"state":_vm.state,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"keypress":_vm.validateKeypress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }